import React from 'react';

function MissingInfoChecklist({ items = [] }) {
  return (
    <div className="ff-card ff-missing-panel" data-testid="missing-info-checklist">
      <h3>Missing Information</h3>
      
      {items.length === 0 ? (
        <p className="ff-complete">
          <span className="ff-check-icon">✓</span>
          Core details are filled in.
        </p>
      ) : (
        <ul className="ff-missing-list">
          {items.map((item, index) => (
            <li key={index}>
              <span className="ff-missing-icon">○</span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default MissingInfoChecklist;
